import { FC } from 'react';

import { FeatureList } from '@eneco/components/ui/FeatureList/FeatureList';
import { useTranslation } from '@eneco/i18n';
import { ClockIcon, ElectricityIcon, TruckIcon } from '@eneco/sparky/icons';

/**
 * Reassurance side panel shown next to the form in the exp-n-477 variant C. The
 * icons are fixed per item; all copy comes from the bundled i18n dictionary
 * (`content/<locale>.json`), consistent with the rest of the combined step.
 */
export const CustomerDetailsHighlights: FC = () => {
  const { t } = useTranslation();

  return (
    <FeatureList
      items={[
        {
          icon: <ClockIcon color="feedbackSuccess" />,
          title: t('highlights.bedenktijd.title'),
          description: t('highlights.bedenktijd.description'),
        },
        {
          icon: <TruckIcon color="feedbackSuccess" />,
          title: t('highlights.overstap.title'),
          description: t('highlights.overstap.description'),
        },
        {
          icon: <ElectricityIcon color="feedbackSuccess" />,
          title: t('highlights.energie.title'),
          description: t('highlights.energie.description'),
        },
      ]}
    />
  );
};
